
import PixLogo from 'base/src/assets/images/logo-pix.png';
import BoletoLogo from 'base/src/assets/images/codigo_de_barras.png';
import styled from 'styled-components';
import { useTheme } from 'base/src/utils/context/themeContext';

export interface ModalAdicionarSaldoProps {
  lote: LotePedidoResponse;
  ValorTotal: string;
  loteId?: number;
  carteiraId: number;
  onClose?: () => void;
}

const CardContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 32px;
`;

interface PaymentCardProps {
  color?: string;
}

const PaymentCard = styled.div<PaymentCardProps>`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 24px 32px;
  border: 1px solid;
  border-color: ${({ color }) => color || '#e0e0e0'};
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 220px;
  cursor: pointer;
  transition: box-shadow 0.2s;
  &:hover {
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  }
`;

const CardImage = styled.img`
  height: 64px;
  margin-bottom: 16px;
`;

const CardTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
`;

const CardDescription = styled.div`
  font-size: 0.95rem;
  color: #666;
  text-align: center;
`;

const HeaderWithBack = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-size: 18px;
  
  &:hover {
    background-color: #f8f9fa;
    color: #495057;
  }
`;

const BackTitle = styled.h3`
  margin: 0;
  color: #495057;
  font-size: 18px;
  font-weight: 600;
`;

import { useState } from 'react';
import { Icon } from '@iconify/react';
import AdicionarSaldoPix from './components/Pix/adicionarSaldoPix';
import AdicionarSaldoBoleto from './components/Boleto/adicionarSaldoBoleto';
import { LotePedidoResponse } from '../../../../types/lotePedido/lotePedidoResponse';

interface PaymentCardsProps {
  // eslint-disable-next-line no-unused-vars
  onSelect: (type: 'pix' | 'boleto') => void;
}

function PaymentCards({ onSelect }: PaymentCardsProps) {
  const { theme } = useTheme();

  function handlePixClick() {
    onSelect('pix');
  }

  function handleBoletoClick() {
    onSelect('boleto');
  }

  return (
    <CardContainer>
      <PaymentCard color={theme.colors.primary} onClick={handlePixClick}>
        <CardImage src={PixLogo} alt="PIX" />
        <CardTitle>PIX</CardTitle>
        <CardDescription>Receba saldo instantaneamente usando QR Code ou copia e cola.</CardDescription>
      </PaymentCard>
      <PaymentCard color={theme.colors.primary} onClick={handleBoletoClick}>
        <CardImage src={BoletoLogo} alt="Boleto" />
        <CardTitle>Boleto</CardTitle>
        <CardDescription>O saldo será liberado após a compensação do boleto bancário.</CardDescription>
      </PaymentCard>
    </CardContainer>
  );
}

function ModalAdicionarSaldo(props: ModalAdicionarSaldoProps) {
  const [selected, setSelected] = useState<'pix' | 'boleto' | null>(null);

  const pagamentoProps = {
    lote: props.lote,
    ValorTotal: props.ValorTotal,
    carteiraId: props.carteiraId,
    onClose: props.onClose,
  };

  function handleBack() {
    setSelected(null);
  }

  return (
    <div>
      {!selected && <PaymentCards onSelect={setSelected} />}
      {selected === 'pix' && (
        <>
          <HeaderWithBack>
            <BackButton onClick={handleBack}>
              <Icon icon="ph:arrow-left" />
            </BackButton>
            <BackTitle>Pagamento via PIX</BackTitle>
          </HeaderWithBack>
          <AdicionarSaldoPix {...pagamentoProps} />
        </>
      )}
      {selected === 'boleto' && (
        <>
          <HeaderWithBack>
            <BackButton onClick={handleBack}>
              <Icon icon="ph:arrow-left" />
            </BackButton>
            <BackTitle>Pagamento via Boleto</BackTitle>
          </HeaderWithBack>
          <AdicionarSaldoBoleto {...pagamentoProps} />
        </>
      )}
    </div>
  );
}

export default ModalAdicionarSaldo;